import dayjs from 'dayjs';

export function convertTime(time: number) {
	const hours = Math.floor(time);
	const minutes = Math.round((time - hours) * 60);

	return dayjs().hour(hours).minute(minutes).second(0).format('HH:mm');
}